<template>
  <el-dialog
    class="dialog"
    :visible.sync="visible"
    title="设置企业折扣率"
    :close-on-click-modal="false"
    destroy-on-close
  >
    <online-review-quote-rate-table
      ref="rateTable"
      :review-id="reviewId"
      :way-id="wayId"
      :quote-review-opened="quoteReviewOpened"
      :purchase-type="purchaseType"
      :order-id="orderId"
      @getList="getRateList"
    />
    <template v-slot:footer>
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="onConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import OnlineReviewQuoteRateTable from '@/components/online-review/review/OnlineReviewQuoteRateTable.vue'
import { purchaseTypeDict } from '@/dictionary/project/common'
import { cloneDeep } from 'lodash'
import { submitPurchaseReviewSupplierQuoteRateApi } from '@/api/procure/purchase-review'

/**
 * 企业折扣率设置弹窗
 */
export default {
  name: 'OnlineReviewQuoteRateDialog',

  components: { OnlineReviewQuoteRateTable },

  props: {
    reviewId: {
      type: [String, Number],
      default: ''
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    // 当前的评审办法id
    wayId: {
      type: [String, Number],
      default: ''
    },

    purchaseType: {
      type: [Number, String],
      default: purchaseTypeDict.INQUIRY.value
    },

    // 价格分评审是否已开启，开启后不能设置折扣率
    quoteReviewOpened: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      visible: false,

      list: [],
      bidderList: []
    }
  },

  methods: {
    openDialog() {
      this.visible = true
    },

    closeDialog() {
      this.visible = false
      this.list = []
    },

    getRateList(list) {
      this.list = cloneDeep(list)
    },

    onConfirm() {
      if (this.quoteReviewOpened) {
        this.closeDialog()
        return
      }
      if (this.list.some(item => !item.offerRate)) {
        this.$message.warning('企业折扣率不能为空')
        return
      }
      submitPurchaseReviewSupplierQuoteRateApi(this.reviewId, this.list)
        .then(res => {
          this.$message.success('提交成功')
          this.closeDialog()
          this.$emit('afterSubmit')
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.modal-body__operation {
  width: 100%;
  border: 1px dashed #d9d9d9;
  text-align: center;
  cursor: pointer;

  &:hover {
    border-color: $primary-color;
    color: $primary-color;
  }
}
</style>
